<mt-banner class="sw-in-app-purchase-price-box" :hide-icon="true">
    <span class="sw-in-app-purchase-price-box__price_container">
        <span class="sw-in-app-purchase-price-box__price">
            {{ currencyFilter(String(priceModel?.price), "EUR", 2) }}*
        </span>

        <span v-if="rentDuration" class="sw-in-app-purchase-price-box__duration">
            /{{ $t('sw-in-app-purchase-price-box.duration.' + rentDuration) }}
        </span>
    </span>
</mt-banner>
